module.exports = __webpack_public_path__ + "static/media/pastoral smart heading.77f67012.svg";